import { render, staticRenderFns } from "./ConnectedFail.vue?vue&type=template&id=6770ccca&scoped=true&"
import script from "./ConnectedFail.vue?vue&type=script&lang=js&"
export * from "./ConnectedFail.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedFail.vue?vue&type=style&index=0&id=6770ccca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770ccca",
  null
  
)

export default component.exports